import { useRef as r } from "react";
import { useIsoMorphicEffect as t } from './use-iso-morphic-effect.js';
function f() {
  var e = r(!1);
  return t(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), e;
}
export { f as useIsMounted };